export const CANCEL_JOIN_REQUEST_DIALOG = 'CANCEL_JOIN_REQUEST_DIALOG';
export const PRIVATE_PROFILE_DISCLAIMER_DIALOG =
  'PRIVATE_PROFILE_DISCLAIMER_DIALOG';
export const LEAVE_GROUP_DIALOG = 'LEAVE_GROUP_DIALOG';
export const JOIN_GROUP_DIALOG = 'join-group-dialog';
